import React from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "../../components/admin/AdminSidebar";
import AdminHeader from "../../components/layout/AdminHeader";
import Footer from "../../components/layout/Footer";

const AdminLayout: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <AdminHeader />
      <div className="flex flex-1 relative">
        <div className="hidden md:block md:w-64 flex-shrink-0">
          <AdminSidebar />
        </div>
        <main className="flex-1 p-4 md:p-6 bg-gray-100 overflow-x-hidden">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default AdminLayout;
